const routes = [
  {
    path: "/student/visualimpairments",
    component: () =>
      import("@/views/student/studentVisualImpairments/Wrapper.vue"),
    children: [
      {
        path: "",
        name: "StudentsVisualImpairments",
        component: () =>
          import("@/views/student/studentVisualImpairments/Main.vue")
      },
      {
        path: "/student/visualimpairments/:id",
        name: "StudentsVisualImpairmentsEnterRecord",
        component: () =>
          import("@/views/student/studentVisualImpairments/EnterRecord.vue")
      }
    ]
  }
];

export default routes;
